/* Picks the dashboard widget for a layout entry. A money widget left in the layout
   of someone without Stats access says so (never $0); Team also needs CRM access. */

import { useTranslation } from 'react-i18next';
import { useDash } from '../context';
import { TYPES } from '../model';
import { BodyNote, WidgetFrame, type FrameProps } from '../WidgetFrame';
import { AccountList } from './AccountList';
import { Attention } from './Attention';
import { BarChart } from './BarChart';
import { Breakdown } from './Breakdown';
import { KeyNumbers } from './KeyNumbers';
import { Team } from './Team';

export function WidgetView(p: FrameProps) {
  const { t } = useTranslation('dashboardWidgets');
  const { access } = useDash();
  const w = p.widget;
  if (TYPES[w.type].money && !access.stats) {
    return <WidgetFrame {...p}><BodyNote icon="lock">{t('widget.noAccess')}</BodyNote></WidgetFrame>;
  }
  switch (w.type) {
    case 'kpi': return <KeyNumbers {...p} widget={w} />;
    case 'chart': return <BarChart {...p} widget={w} />;
    case 'split': return <Breakdown {...p} widget={w} />;
    case 'accounts': return <AccountList {...p} widget={w} />;
    case 'needs': return <Attention {...p} widget={w} />;
    case 'team': return access.crm ? <Team {...p} widget={w} /> : <WidgetFrame {...p}><BodyNote icon="lock">{t('widget.noCrm')}</BodyNote></WidgetFrame>;
  }
}
